import { AnalyticsConfigV1 } from '@csp/config-schemas';
import { Maybe, AnalyticsConfig } from '@csp/csp-common-model';

const toAnalyticsConfig = (config: Maybe<AnalyticsConfigV1>): Maybe<AnalyticsConfig> => config;

export const AnalyticsConfigService = {
  toAnalyticsConfig,
};
